// extracted by mini-css-extract-plugin
module.exports = {"content":"Amount_content__18hKI","invalidAmountError":"Amount_invalidAmountError__3l3Da","errorSpacing":"Amount_errorSpacing__uXxv7"};